exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".breakdowns[data-v-7d61151a]{text-align:left;width:400px;margin:0 auto}.breakdowns .block[data-v-7d61151a]{margin:0;position:relative;top:.125rem}.percent[data-v-7d61151a]{width:75px;text-align:right}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-7d61151a&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./dev/src/views/RealtimeView.vue
// module id = ./node_modules/css-loader/index.js?minimize!./node_modules/vue-loader/lib/style-rewriter.js?id=data-v-7d61151a&scoped=true!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./dev/src/views/RealtimeView.vue
// module chunks = 0